import { render, staticRenderFns } from "./CardArtefatoGeral.vue?vue&type=template&id=5efda213&scoped=true"
import script from "./CardArtefatoGeral.vue?vue&type=script&lang=js"
export * from "./CardArtefatoGeral.vue?vue&type=script&lang=js"
import style0 from "./CardArtefatoGeral.vue?vue&type=style&index=0&id=5efda213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efda213",
  null
  
)

export default component.exports